import { DateTime } from 'luxon';

import { DASH } from '@/globals';
import Validatable from '@/validator/Validatable';

interface IHeaderBidderPresetAPI {
  headerBidderPreset_id: number;
  name: string;
  created_by: string;
  created_on_utc?: string;
  modified_by: string;
  modified_on_utc?: string;
  organization_id: number;
  archived: boolean;
}

export default class HeaderBidderPreset extends Validatable {
  id: number;

  name: string;

  createdBy: string;

  createdOnUtc?: DateTime;

  modifiedBy: string;

  modifiedOnUtc?: DateTime;

  organizationId: number;

  archived: boolean;

  timestamp: DateTime;

  constructor(
    id: number,
    name: string,
    createdBy: string,
    createdOnUtc?: DateTime,
    modifiedBy: string,
    modifiedOnUtc?: DateTime,
    organizationId: number,
    archived = false,
  ) {
    super();
    this.id = id;
    this.name = name;
    this.createdBy = createdBy;
    this.createdOnUtc = createdOnUtc;
    this.modifiedBy = modifiedBy;
    this.modifiedOnUtc = modifiedOnUtc;
    this.organizationId = organizationId;
    this.archived = archived;
    this.timestamp = DateTime.local();
  }

  static fromApi(apiObject: IHeaderBidderPresetAPI): HeaderBidderPreset {
    return new HeaderBidderPreset(
      apiObject.headerBidderPreset_id,
      apiObject.name,
      apiObject.created_by,
      apiObject.created_on_utc !== null ? DateTime.fromISO(apiObject.created_on_utc, { zone: 'utc' }) : null,
      apiObject.modified_by,
      apiObject.modified_on_utc !== null ? DateTime.fromISO(apiObject.modified_on_utc, { zone: 'utc' }) : null,
      apiObject.organization_id,
      apiObject.archived,
    );
  }

  get createdOnFormatted(): string {
    return this.createdOnUtc !== null ? this.createdOnUtc.toLocal().toLocaleString(DateTime.DATETIME_MED) : DASH;
  }

  get modifiedOnFormatted(): string {
    return this.modifiedOnUtc !== null ? this.modifiedOnUtc.toLocal().toLocaleString(DateTime.DATETIME_MED) : DASH;
  }

  get endpoint(): string {
    return `/header-bidder-presets/${this.id}`;
  }

  static fromObject(obj: HeaderBidderPreset): HeaderBidderPreset {
    return super.fromObject(obj, new HeaderBidderPreset(0, '', '', null, '', null, 0, false));
  }

  toApi(): IHeaderBidderPresetAPI {
    return {
      headerBidderPreset_id: this.id,
      name: this.name,
      created_by: this.createdBy,
      created_on_utc: this.createdOnUtc,
      modified_by: this.modifiedBy,
      modified_on_utc: this.modifiedOnUtc,
      organization_id: this.organizationId,
      archived: this.archived,
    };
  }

  static validatorCreateRules(): Record<string, string> {
    return {
      name: 'required|max:191|not_empty_or_whitespace',
    };
  }
}
